import { Component, Input, OnInit } from '@angular/core';
import { AppClientConfigurationService, TranslationService } from '@sdbn/common';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { AsyncSubject } from 'rxjs';
import { MessagingProvider } from '../../../../client/model/messagingprovider';
import { TransportPlanningType } from '../../../../common/model/transport.model';
import { YardPropertiesService } from '../../../../yard-properties.service';
import { TmcContextService } from './../../../../common/tmc-context.service';
import { ParamterType } from './../../model/paramter-type.enum';
import { RegistrationStepperModel } from './../../model/registration-step-model';
import { SupplementaryEquipment } from './../../model/supplementary-equipment';
import { TransportRegistration } from './../../model/transport-registration';

@Component({
    selector: 'app-supplementary-equipment',
    templateUrl: './supplementary-equipment.component.html',
    styleUrls: ['./supplementary-equipment.component.scss'],
    standalone: false
})
export class SupplementaryEquipmentComponent implements OnInit {

  @Input() registration: TransportRegistration;
  @Input() stepperModel: RegistrationStepperModel;

  clientParameters = TMCClientParameters;
  planningType = TransportPlanningType;

  constructor(
    private tmcContextService: TmcContextService,
    public translationService: TranslationService,
    public yardPropertiesService: YardPropertiesService,
    public cps: AppClientConfigurationService) { }

  ngOnInit() {
    this.stepperModel.stepCompleted = () => {
      return this.isStepCompleted();
    };

    this.stepperModel.beforeShowNextStep = () => {
      const subject = new AsyncSubject<boolean>();
      subject.next(true);
      subject.complete();
      return subject;
    };
  }

  isNoSupplementaryEquipmentHandoutDisabled(): boolean {
    if (this.registration.supplementaryEquipments != null
      && this.registration.supplementaryEquipments.length > 0
      && this.registration.supplementaryEquipments.some(se => se.selected)) {
      return true;
    }
    return false;
  }

  isNoSupplementaryEquipmentHandoutSelected(): boolean {
    return this.registration.noSupplementaryEquipmentHandout === true;
  }

  private isStepCompleted(): boolean {

    if (this.yardPropertiesService.isHideInRegisterTransportEnabled()) {
      return true;
    }

    // bei Vorabanmeldung muss nur geprüft werden, wenn "jetzt einbuchen" gesetzt ist
    if ((this.registration.transport.timing.planningType === TransportPlanningType.IN_ADVANCE
      || this.registration.transport.timing.planningType === TransportPlanningType.TIMEFRAME
    ) && !this.registration.registerNow) {
      return true;
    }

    // wenn keine "Bestätigung Begleitmittel nötig" konfiguriert
    if (!this.yardPropertiesService.isShowNoHandoutEnabled()) {

      // ungültige Eingaben prüfen
      for (const se of this.registration.supplementaryEquipments) {
        if (se.selected) {
          if (se.availableIdentifiers?.length > 0 && se.selectedIdentifier == null) {
            return false;
          }
        }
      }

      return true;
    }

    if (this.registration.noSupplementaryEquipmentHandout) {
      return true;
    }

    if (this.registration.supplementaryEquipments.length === 0) {
      return true;
    }

    let validCount = 0;
    for (const se of this.registration.supplementaryEquipments) {
      if (se.selected) {
        if (se.availableIdentifiers?.length > 0 && se.selectedIdentifier == null) {
          return false;
        } else {
          validCount += 1;
        }
      }
    }

    return validCount > 0;
  }

  availableMessagingProvider(): Array<MessagingProvider> {
    return this.tmcContextService.getAvailableMessagingProvider();
  }

  getMessagingProviderLabel(messagingProvider: MessagingProvider): string {
    if (messagingProvider.dictionaryKey) {
      return this.translationService.translate(messagingProvider.label);
    }
    return messagingProvider.label;
  }

  /** translates the messaging language keys using the current language and orders them alpabetically */
  public getMessagingLanguagesOrdererByCurrentTranslation() {

    let configuredLanguagesValue = this.cps.getPropertyValue("tmc-yard.messaging.allowed-languages");
    const configuredLanguages = configuredLanguagesValue.split("|");

    return configuredLanguages.sort((a, b) => {
      const ta = this.translationService.translate('common.enum.language.' + a);
      const tb = this.translationService.translate('common.enum.language.' + b);
      return ta > tb ? 1 : ta === tb ? 0 : -1;
    });
  }

}
